module.exports = __webpack_public_path__ + "static/media/logo.b18dd735.png";